/* global MERCHANTID APIURL LANDINGURL AUTHURL AUTH_MODE ENV MERCHANTID GAID */

const app = angular.module('msi.core.constants', ['og-sdk']);

/**
 * This block sets de default constant configuration defined in webpack.
 * app.constant() can be called before to override this logic.
 * At this point configuration comes from webpack build variables
 */
app.config([
  '$provide',
  '$injector',
  ($provide, $injector) => {
    const constants = {
      merchantId: MERCHANTID,
      env: ENV,
      authMode: AUTH_MODE,
      authUrl: AUTHURL,
      config: { landingPageUrl: LANDINGURL },
      apiUrls: { masterDbUrl: APIURL },
      analyticsId: GAID,
      // eslint-disable-next-line no-undef
      publicPath: __webpack_require__.p
    };

    Object.entries(constants).forEach(([key, val]) => {
      if (!$injector.has(key)) {
        $provide.constant(key, val);
      }
    });
  }
]);

app.run([
  'publicPath',
  (publicPath) => {
    // This is a globally exposed variable that changes the public path during runtime in webpack.
    // This is definitely a hack, but there's no way to change the public path after build.

    // eslint-disable-next-line no-undef, camelcase
    if (__webpack_require__) __webpack_require__.p = publicPath;
  }
]);

app.constant('countries', require('./countries'));
app.constant('ccTypes', require('./cc-types'));

app.constant('ccTypeMap', {
  1: 'Visa',
  2: 'Mastercard',
  3: 'American Express',
  4: 'Discover'
});

// Quantity type: input | select
app.constant('qtyType', 'select');
// quantities for select | quantities min-max for inputs
app.constant('quantities', [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
// quantities min-max and buttons +/- for inputs
app.constant('qtyInputConfig', { min: 1, max: 20, buttons: false });

app.constant('billingConfig', {
  visible: true,
  hostedByOg: true,
  url: ''
});

app.constant('shippingConfig', {
  hostedByOg: true,
  url: ''
});

module.exports = app.name;
